import { EStatusMessageType } from '../StatusMessageType/StatusMessageType';

export interface IStatusMessage {
	text: string;
	type: EStatusMessageType;
	duration?: number;
}

export const emptyStatusMessage: IStatusMessage = {
	text: '',
	type: EStatusMessageType.info
};
